import { Tooltip } from '@mui/material';
import {
  InfoOutlined as InfoIcon,
  WarningAmberRounded as WarningIcon,
} from '@mui/icons-material';
import { ShippingListDriverNotices } from '../models';

interface DriverNoticesIndicatorProps {
  notices?: ShippingListDriverNotices | null;
}

const describePending = (pending: number): string =>
  pending === 1
    ? 'El pedido cambió y el conductor todavía no vio el aviso'
    : `El pedido cambió y el conductor todavía no vio ${pending} avisos`;

const DriverNoticesIndicator = ({ notices }: DriverNoticesIndicatorProps) => {
  if (!notices?.total) return null;

  const hasPending = notices.pending > 0;
  const title = hasPending
    ? describePending(notices.pending)
    : notices.total === 1
      ? 'El pedido cambió y el conductor ya vio el aviso'
      : 'El pedido cambió y el conductor ya vio los avisos';

  return (
    <Tooltip title={title} arrow>
      <span
        className={`inline-flex ${hasPending ? 'text-amber-500' : 'text-gray-400'}`}
        aria-label={title}
        role='img'
      >
        {hasPending ? (
          <WarningIcon sx={{ fontSize: 18 }} />
        ) : (
          <InfoIcon sx={{ fontSize: 18 }} />
        )}
      </span>
    </Tooltip>
  );
};

export default DriverNoticesIndicator;
